import React from "react";

export const flagSvIcon = (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M0 3H24V21H0V3Z' fill='#066AA7' />
    <path d='M0 10.2002H24V13.8002H0V10.2002Z' fill='#FECC00' />
    <path d='M6.59961 3H10.1996V21H6.59961V3Z' fill='#FECC00' />
  </svg>
);
